import { Button, Dropdown, P } from '@dnb/eufemia';
import { email as MailIcon } from '@dnb/eufemia/icons';
import { useNavigate } from 'react-router-dom';

import { ApiDetailedResponseEnvironmentRelease } from '@/openapi/schema';
import { DoNavigateProps } from '@/pages/api-documentation/ApiDocumentation';

import type { DropdownOption } from '../constants/types';

import { StyledButtonWrapper, StyledEnvironment, StyledHeaderControls } from '../styles/Api.styles';

export interface HeaderType {
  environments?: DropdownOption[];
  releases?: DropdownOption[];
  selectedVersion: string | null;
  selectedEnvironment: string | null;
  doNavigate: (props: DoNavigateProps) => void;
  latestMajorReleases?: ApiDetailedResponseEnvironmentRelease[];
  selected?: string | null;
  canSubscribe: boolean;
  hideVersions?: boolean;
}

const HeaderControls = ({
  environments,
  selectedEnvironment,
  releases,
  selectedVersion,
  doNavigate,
  latestMajorReleases,
  selected,
  canSubscribe,
  hideVersions = false,
}: HeaderType) => {
  const navigate = useNavigate();

  const hasVersionedReleases = latestMajorReleases != null && latestMajorReleases.length > 0;

  return (
    <StyledHeaderControls>
      <StyledEnvironment>
        {environments && environments.length > 0 && (
          <Dropdown
            data={environments}
            label="Environment"
            labelDirection="vertical"
            onChange={({ data }) => {
              doNavigate({ env: String(data?.selectedKey) });
            }}
            title="Select environment"
            value={environments.findIndex((option) => option.selectedKey === selectedEnvironment)}
          />
        )}

        {!hideVersions && environments && environments.length > 0 && releases && releases.length > 0 && (
          <div className="flex flex-col gap-2">
            {hasVersionedReleases && <P>Version</P>}
            <div className="flex flex-wrap items-center gap-4">
              {hasVersionedReleases &&
                latestMajorReleases.map((release) => (
                  <Button
                    key={release.version}
                    onClick={() => doNavigate({ release: release.version })}
                    size="medium"
                    tooltip={`Version name: ${release.name}`}
                    variant={release.version === selectedVersion ? 'secondary' : 'tertiary'}
                  >
                    {release.version}
                  </Button>
                ))}
              <Dropdown
                data={releases}
                independentWidth
                label={hasVersionedReleases ? undefined : 'Version'}
                labelDirection="vertical"
                onChange={({ data }) => {
                  doNavigate({ release: String(data?.selectedKey) });
                }}
                preventSelection={hasVersionedReleases}
                title="Select version"
                value={releases.findIndex((option) => option.selectedKey === selectedVersion)}
              />
            </div>
          </div>
        )}
      </StyledEnvironment>
      <StyledButtonWrapper>
        {canSubscribe && (
          <Button
            icon={MailIcon}
            iconPosition="left"
            onClick={() => navigate(`/subscriptions/releases/${selected}`)}
            variant="secondary"
          >
            Subscribe
          </Button>
        )}
      </StyledButtonWrapper>
    </StyledHeaderControls>
  );
};

export default HeaderControls;
